import React from "react";
import { Facebook, Instagram, Linkedin, Twitter, Globe } from "lucide-react";

/**
 * Returns the appropriate Lucide icon element for a given social-media platform name.
 */
export const iconForPlatform = (platform?: string): React.ReactElement => {
  switch (String(platform || "").toUpperCase()) {
    case "FACEBOOK":
      return <Facebook size={18} />;
    case "INSTAGRAM":
      return <Instagram size={18} />;
    case "LINKEDIN":
      return <Linkedin size={18} />;
    case "TWITTER":
      return <Twitter size={18} />;
    case "WEBSITE":
      return <Globe size={18} />;
    default:
      return <Globe size={18} />;
  }
};
